import React,{useEffect,useState} from "react";
import unsplash from "../api/unsplash";
import { DataGrid, GridToolbar, itIT ,GridValueGetterParams } from '@mui/x-data-grid';
import {IconButton,Button,Dialog,DialogTitle,DialogContent,Grid,TextField,FormControl,InputLabel,Select,MenuItem,Popover,DialogActions,Box,Typography,Step,StepLabel,Stepper,CircularProgress} from '@mui/material';

const ProtocolloSanitarioLavoratore = (props) => {

    const columns = [
        { field: 'NomeAccertamento', headerName: 'Accertamento', width: 300 }
      ];


const [protocollo,setProtocollo] = useState()
    useEffect(() => {// è un loop qui carico i dati 
        const fetchData = async () =>{
            let responseProtocollo =  await unsplash
            .get('protocolloSanitario',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{lavoratore:props.lavoratore}}
             );

      
          setProtocollo(responseProtocollo.data.data);
          console.log(responseProtocollo.data.data);
        }
    
        fetchData();
     
      }, []);




    return (
<Grid item xs={12}>
  <div style={{ height: 400, width: '100%' }}>
  <DataGrid
      disableSelectionOnClick
      disableColumnMenu={true}
      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      rows={protocollo}
      getRowId={protocollo => protocollo.ID}
      columns={columns}
    />
      
    

    </div>

  </Grid>  

    )
}

export default ProtocolloSanitarioLavoratore;